import React from 'react';

interface QuickActionProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const QuickAction: React.FC<QuickActionProps> = ({ icon, title, description }) => {
  return (
    <button className="flex w-full items-start gap-4 rounded-xl border border-[#F2F4F7] bg-gray-50 p-5 text-left transition-all hover:bg-gray-100 hover:border-gray-300">
      <div className="rounded-lg bg-white p-2.5 shadow-sm">{icon}</div>
      <div>
        <p className="font-semibold text-gray-900">{title}</p>
        <p className="text-sm text-gray-500 mt-1">{description}</p>
      </div>
    </button>
  );
};

export default QuickAction;
